import React from 'react'
import ServicesComponent from '../components/Services'

function Services() {
  return (
    <div className="services-page">
      <ServicesComponent />
    </div>
  )
}

export default Services